import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import * as blueprint from '@adc/blueprint';
import ScrollSpy from '../../../layouts/scrollspy';
export class AdditionalTermsBadge extends blueprint.listing.badges
    .AdditionalTermsBadge {
    get content() {
        return (_jsxs(_Fragment, { children: ["Review additional documents", ' ', _jsx(ScrollSpy, { selector: '#due_diligence', children: ({ scrollTo }) => _jsx("a", { onClick: scrollTo, children: ` here` }) }), "."] }));
    }
}
//# sourceMappingURL=additionalTerms.js.map